/* bc-carousel — shared carousel: track + dots + arrows. Arrows disable, don't hide, at the ends. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bc-carousel]').forEach(initCarousel);
  });

  function initCarousel(root) {
    var track = root.querySelector('.bc-carousel__track');
    var dotsWrap = root.querySelector('.bc-carousel__dots');
    var controlsWrap = root.querySelector('.bc-carousel__controls');
    var prevBtn = root.querySelector('[data-arrow="prev"]');
    var nextBtn = root.querySelector('[data-arrow="next"]');

    if (!track) return;

    var cards = track.querySelectorAll('.bc-carousel__card');
    if (!cards.length) return;

    var currentPage = 0;

    function getVisibleCount() {
      var w = window.innerWidth;
      if (w <= 749) return 1;
      if (w <= 989) return 2;
      return 3;
    }

    function getTotalPages() {
      return Math.max(1, Math.ceil(cards.length / getVisibleCount()));
    }

    function buildDots() {
      var totalPages = getTotalPages();
      /* Dots add nothing over the arrows at 2 pages; arrows add nothing at 1. */
      if (dotsWrap) dotsWrap.classList.toggle('is-hidden', totalPages <= 2);
      if (controlsWrap) controlsWrap.classList.toggle('is-hidden', totalPages <= 1);

      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.className = 'bc-carousel__dot' + (i === currentPage ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.setAttribute('data-page', i);
        dot.addEventListener('click', function () {
          goToPage(parseInt(this.getAttribute('data-page')));
        });
        dotsWrap.appendChild(dot);
      }
    }

    /* Real scroll bounds, not an assumed page count — avoids drift when cards don't divide evenly. */
    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function goToPage(page) {
      var totalPages = getTotalPages();
      if (page < 0) page = 0;
      if (page > totalPages - 1) page = totalPages - 1;
      currentPage = page;

      var gap = parseInt(getComputedStyle(track).gap) || 32;
      var cardWidth = cards[0].offsetWidth + gap;
      var target = currentPage * getVisibleCount() * cardWidth;
      target = Math.max(0, Math.min(target, getMaxScroll()));
      track.scrollTo({ left: target, behavior: 'smooth' });

      updateDots();
      updateArrows();
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.bc-carousel__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === currentPage);
      });
    }

    /* Nowhere to scroll — disable, don't remove. */
    function updateArrows() {
      var maxScroll = getMaxScroll();
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    /* Scroll sync */
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var gap = parseInt(getComputedStyle(track).gap) || 32;
        var cardWidth = cards[0].offsetWidth + gap;
        var scrollPage = Math.round(track.scrollLeft / (cardWidth * getVisibleCount()));
        scrollPage = Math.max(0, Math.min(scrollPage, getTotalPages() - 1));
        if (scrollPage !== currentPage) {
          currentPage = scrollPage;
          updateDots();
        }
        updateArrows();
      }, 100);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goToPage(currentPage - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goToPage(currentPage + 1); });
    }

    /* Rebuild dots only when the visible-card count actually changes (mobile fires resize on scroll). */
    var resizeTimer;
    var lastVisibleCount = getVisibleCount();
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var visibleCount = getVisibleCount();
        if (visibleCount === lastVisibleCount) return;
        lastVisibleCount = visibleCount;
        currentPage = 0;
        buildDots();
        updateArrows();
        track.scrollTo({ left: 0 });
      }, 200);
    });

    buildDots();
    updateArrows();
  }
})();
